import React from "react";
import Hidden from "@material-ui/core/Hidden";
import QuestionGroupHeaderMobile from "./QuestionGroupHeaderMobile";
import QuestionGroupHeaderDesktop from "./QuestionGroupHeaderDesktop";

interface QuestionGroupHeaderProps {
  title: string;
}
const QuestionGroupHeader: React.FC<QuestionGroupHeaderProps> = (
  props: QuestionGroupHeaderProps
) => {
  return (
    <React.Fragment>
      <Hidden smDown>
        <QuestionGroupHeaderDesktop {...props} />
      </Hidden>
      <Hidden mdUp>
        <QuestionGroupHeaderMobile {...props} />
      </Hidden>
    </React.Fragment>
  );
};

export default QuestionGroupHeader;
